import React, { useEffect, useState, forwardRef } from "react";
import { Header } from '../../components/Header/Header';
import { Navigator } from '../../components/Navigator/Navigator';
import photo from "../../assets/Profile/Profile-IMG.png";
import { api } from "../../context/Auth";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { set, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import axios from "axios";
import { ModalAddPP } from "../../components/ModalAddPP";

function TermsAndConditions() {


    const {
        enterprise,
        loading,
        user,
        updateProfileEnterprise,
        getProfileAcknowledge,
        updateNemuProfile,
      } = useAuth(); // Obtén la función de registro desde el contexto
      let userid;
      const {
        register,
        handleSubmit,
        formState: { errors },
        watch,
        setValue,
      } = useForm();
    
      const [activeTab, setActiveTab] = useState(1);
      const [text1, setText1] = useState(""); // Estado para el primer texto (límite 400)
      const [preview, setPreview] = useState(photo);
      const [userId, setUserId] = useState(userid);
      const [openModalPP, setOpenModalPP] = useState(false);
      const [openModal, setOpenModal] = useState(false);
      const [coverPage, setCoverPage] = useState(null);
      const [profile_picture, setProfilePicture] = useState(null);
      const [acknowledge, setAcknowledge] = useState(null);
      const closeModal = () => {
        setOpenModal(false);
      };
    
       // Función para abrir el modal
       const openModalPPHandler = () => {
        setOpenModalPP(true);
      };
    
      // Función para cerrar el modal
      const closeModalPPHandler = () => {
        setOpenModalPP(false);
      };
    
    
      const handleChange1 = (e) => {
        if (e.target.value.length <= 400) {
          setText1(e.target.value);
        }
      };
    
      const fetchProfileAcknowledge = async (id) => {
        try {
          const response = await getProfileAcknowledge(id);
          console.log(response.data);
          setAcknowledge(response.data);
        } catch (error) {
          console.error("Error al obtener el perfil de la empresa:", error);
        }
      };
    
      useEffect(() => {
        // console.log(loading);
        // console.log(enterprise);
        if (enterprise) {
          // console.log("Enterprise");
          // console.log(enterprise);
          // console.log("User");
          // console.log(user);
          // console.log("User ID");
          userid = user.id;
          setUserId(userid);
          //console.log(userid);
          //  console.log("Cover Page");
          if (enterprise.profile_picture) {
            setPreview(api + "/" + enterprise.profile_picture);
          } else {
            setPreview(photo);
          }
    
          if (enterprise.profile.cover_page) {
            setCoverPage(api + "/" + enterprise.profile.cover_page);
          } else {
            setCoverPage(photo);
          }
    
          console.log(coverPage);
          setValue("descripcion", enterprise.profile.descripcion); // Establece el valor inicial
          fetchProfileAcknowledge(user.id);
        }
      }, [enterprise, setValue]);
    
      const handleImageChange = async (e) => {
        const file = e.target.files[0];
    
        if (file) {
          // Mostrar preview
          const reader = new FileReader();
          reader.onloadend = () => {
            setPreview(reader.result);
          };
          reader.readAsDataURL(file);
    
          // Preparar y enviar la imagen
          try {
            const formData = new FormData();
            formData.append("image", file);
    
            const response = await axios.patch(
              `${api}/user/update-picture/${user.id}`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            );
    
            if (response.data.success) {
              Swal.fire({
                icon: "success",
                title: "¡Imagen actualizada!",
                showConfirmButton: false,
                timer: 1500,
              });
            }
          } catch (error) {
            console.error("Error al actualizar la imagen:", error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "No se pudo actualizar la imagen",
              showConfirmButton: true,
            });
          }
        }
      };
    
      const descriptionValue = watch("descripcion", ""); // Observa el valor de "description"
    
      const onSubmit = async (data) => {
        console.log(data);
        try {
          await updateProfileEnterprise(user.id, data);
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Usuario o contraseña incorrectos",
          });
        }
      };
    
      const onSubmit2 = async (data) => {
        console.log(data);
        try {
          const response = await updateNemuProfile(user.id, data);
    
          if (response) {
            Swal.fire({
              icon: "success",
              title: "¡Datos actualizados!",
              text: "Los datos de tu empresa han sido actualizados correctamente",
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "¡Ha ocurrido un error!",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      };
    
    return (
    <div>
        <main className="w-[100vw] max-w-[100vw] bg-[#eaeaea]">
            <Header />
            <div className="flex h-full w-full pr-[20px] pb-[20px] ">
                <Navigator />
                <div className="grid grid-cols-[1fr_3fr] w-full gap-[10px]">
                    <div className="flex flex-col gap-[2px] ">
                        <div className="w-full bg-white p-[8px] max-h-[calc(100svh-120px)] overflow-y-auto rounded-[4px] ">
                            <div className="flex flex-col gap-[10px] ">
                                {enterprise.profile.profile_picture ? (
                                <div className="relative group">
                                <img
                                    className="w-full"
                                    src={coverPage}
                                    alt="photo_profile"
                                />
                                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity">
                                    <label className="cursor-pointer p-2 rounded-full bg-white hover:bg-gray-100">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-6 w-6 text-gray-600"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                                        />
                                        <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                                        />
                                    </svg>
                                    <input
                                        type="file"
                                        className="hidden"
                                        accept="image/*"
                                        onChange={handleImageChange}
                                    />
                                    </label>
                                </div>
                                </div>
                                ) : (
                                    <div className="relative group">
                                        <img
                                            className="w-full hover:opacity-80 transition-opacity"
                                            src={preview || photo}
                                            alt="photo_profile"
                                        />

                                        {/* Overlay con ícono de cámara al hover */}
                                        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity">
                                            <label className="cursor-pointer p-2 rounded-full bg-white hover:bg-gray-100">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-6 w-6 text-gray-600"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                                                />
                                                <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                                                />
                                            </svg>
                                            <input
                                                type="file"
                                                className="hidden"
                                                accept="image/*"
                                                onChange={handleImageChange}
                                            />
                                            </label>
                                        </div>
                                    </div>
                                )}
                                <div className="flex flex-col gap-[4px] ">
                                    <h1 className="text-[24px] ">
                                    {enterprise.enterprise.name}
                                    </h1>
                                    <span className="text-[12px]">
                                    {enterprise.enterprise.address}
                                    </span>
                                </div>
                                </div>
                            </div>
                            <div className="flex w-full bg-white justify-between px-[16px] py-[12px] h-min rounded-[4px] ">
                                <h1 className="text-[20px] ">Número de proyectos</h1>
                                <h1 className="text-[20px]">12</h1>
                            </div>
                            <div className="flex flex-col w-full bg-white justify-between px-[16px] py-[12px] h-min rounded-[4px] ">
                                <span className="text-[12px]">Miembro de Nemu desde</span>
                                {new Date(enterprise.createdAt).toLocaleDateString()}
                            </div>
                    </div>
                    <div className="flex flex-col w-full max-h-[calc(100svh-120px)] overflow-y-auto py-8 px-6 bg-white rounded-[4px] gap-[20px] ">
                        <ul className="flex gap-1">
                            <li
                            onClick={() => setActiveTab(1)}
                            className={`cursor-pointer m-[10px] pb-1 border-b-2 hover:scale-[1.05] transition-all duration-200  ${
                                activeTab == 1
                                ? "border-nemu-azul text-black"
                                : "border-transparent text-nemu-plata"
                            }`}
                            >
                            <span>Terminos y Condiciones</span>
                            </li>
                            <li
                            onClick={() => setActiveTab(2)}
                            className={`cursor-pointer m-[10px] pb-1 border-b-2 hover:scale-[1.05] transition-all duration-200  ${
                                activeTab == 2
                                ? "border-nemu-azul text-black"
                                : "border-transparent text-nemu-plata"
                            }`}
                            >
                            <span>Políticas de Privacidad</span>
                            </li>
                        </ul>
                        <hr className="border-t-1 border-nemu-plata" />
                        {activeTab == 1 && (
                            <div className="flex flex-col w-full p-4 space-y-4 mx-auto">
                            <h1 className="text-[1.8svh] font-semibold">Términos y condiciones</h1>
                            <p className="text-lg">
                            <p className="text-base mb-6">
                                                Terms and Conditions
                            </p>
                            <p className="text-base ">
                            1. Introduction
                            </p>
                            <p className="text-base mb-6">
                            Welcome to our platform! These Terms and Conditions outline the rules and regulations for the use of our services. By accessing this website, you agree to comply with these terms.
                            </p>
                            <p className="text-base">
                            2. Acceptance of Terms
                            </p>
                            <p className="text-base mb-6">
                            By using our services, you confirm that you have read, understood, and agree to be bound by these Terms and Conditions. If you do not agree, please refrain from using our services.
                            </p>
                            <p className="text-base">
                            3. Changes to Terms
                            </p>
                            <p className="text-base mb-6">
                            We reserve the right to modify these Terms at any time. Any changes will be effective immediately upon posting on this site. It is your responsibility to review these Terms periodically.
                            </p>
                            <p className="text-base">
                            4. User Responsibilities
                            </p>
                            <p className="text-base mb-6">
                            You agree to use our services only for lawful purposes and in a manner that does not infringe on the rights of others. You are responsible for any content you post or share.
                            </p>
                            <p className="text-base">
                            5. Account Security
                            </p>
                            <p className="text-base mb-6">
                            You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account. Notify us immediately of any unauthorized use of your account.
                            </p>
                            <p className="text-base">
                            6. Intellectual Property
                            </p>
                            <p className="text-base mb-6">
                            All content, trademarks, and other intellectual property on our platform are owned by us or our licensors. You may not use any of our intellectual property without our prior written consent.
                            </p>
                            <p className="text-base">
                            7. Limitation of Liability
                            </p>
                            <p className="text-base mb-6">
                            To the fullest extent permitted by law, we shall not be liable for any indirect, incidental, or consequential damages arising from your use of our services.
                            </p>
                            <p className="text-base">
                            8. Governing Law
                            </p>
                            <p className="text-base mb-6">
                            These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which we operate. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the courts in that jurisdiction.
                            </p>
                            <p className="text-base">
                            9. Termination
                            </p>
                            <p className="text-base mb-6">
                            We reserve the right to terminate or suspend your access to our services at any time, without prior notice, for conduct that we believe violates these Terms.
                            </p>
                            <p className="text-base">
                            10. Contact Information
                            </p>
                            <p className="text-base mb-6">
                            If you have any questions about these Terms and Conditions, please contact us at support@example.com. We are here to help!
                            </p>
                            </p>
                            <hr className="border-t-1 border-nemu-plata" />
                            </div>
                        )}
                    </div>
                </div>    
            </div>
        </main>
    </div>
    );
};

export {TermsAndConditions}